<div class="iso-copyright-bottom">
    <span class="left">
        MSP Navigator Site Admin
    </span>
    <span class="center">
      ©2025 Verisk Analytics Inc. All rights reserved.
    </span>
    <span class="right">
        <!-- <span>Version: 6.1.0.1150 | Date: 01/09/2025</span> -->
      <!-- <span *ngIf="FileVersionText">{{getVersionText()}}</span>
      <span *ngIf="!FileVersionText">&nbsp;</span> -->
    </span>
</div>